export const blockUI = () => (dispatch) => dispatch({ type: 'BLOCK_UI' });
export const unblockUI = () => (dispatch) => dispatch({ type: 'UNBLOCK_UI' });